import { render, staticRenderFns } from "./create-account.vue?vue&type=template&id=8a65673a&scoped=true"
import script from "./create-account.vue?vue&type=script&lang=js"
export * from "./create-account.vue?vue&type=script&lang=js"
import style0 from "./create-account.vue?vue&type=style&index=0&id=8a65673a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a65673a",
  null
  
)

export default component.exports